import { createSlice } from '@reduxjs/toolkit';

const licenceValueSlice = createSlice({
    name: 'licenceValue',
    initialState: false,
    reducers: {
        setLicenceValue: (state, action) => action.payload,
    },
});

export const { setLicenceValue } = licenceValueSlice.actions;

export default licenceValueSlice.reducer;
